<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelPerfil"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'nomePerfil'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_perfil_' + this.nomePerfil.toLowerCase(), null);
        return;
      }
      this.$emit('selectChange', 'id_perfil_' + this.nomePerfil.toLowerCase(), e);
    },
    labelPerfil({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      let nomeMetodo = `perfil_${this.nomePerfil}`;
      this.isLoading = true;
      this.$atenaList
        .getCommon(nomeMetodo, {
          columns: '*',
          filter: `id_empresa=${this.$store.state.user.info.id_empresa} and excluido=false`,
          order: 'id'
        })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
          this.isLoading = false;
        });
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
